import React from 'react';

import CollectionOptions from './CollectionOptions/CollectionOptions';
import DeliveryOptions from './DeliveryOptions/DeliveryOptions';
import HelpAndSupportOptions from './HelpAndSupportOptions/HelpAndSupportOptions';
import NotificationOptions from './NotificationOptions/NotificationOptions';
import RemoveOptions from './RemoveOptions/RemoveOptions';
import { SIDE_PANEL_TEST_ID } from './SidePanel.test-ids';

import styles from './SidePanel.module.scss';

const SidePanel: React.FC = () => {
  return (
    <div className={styles.sidePanel} data-testid={SIDE_PANEL_TEST_ID}>
      <div className={styles.accordionOptions}>
        <DeliveryOptions />
        <CollectionOptions />
        <NotificationOptions />
        <HelpAndSupportOptions />
      </div>
      <RemoveOptions />
    </div>
  );
};

export default SidePanel;
